var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineFilterSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.53 22.39c-.89-.5-1.42-1.39-1.42-2.4v-5.35c0-.51-.33-1.26-.64-1.65L3.67 9c-.63-.63-1.12-1.73-1.12-2.54V4.14c0-1.61 1.22-2.87 2.77-2.87h13.34a2.77 2.77 0 0 1 2.77 2.77v2.22c0 1.05-.63 2.26-1.23 2.85-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06c.37-.37.79-1.2.79-1.79V4.04c0-.7-.57-1.27-1.27-1.27H5.32c-.71 0-1.27.6-1.27 1.37v2.32c0 .37.3 1.1.69 1.49L8.59 12c.51.63 1.01 1.69 1.01 2.64v5.35c0 .66.45.98.65 1.09.43.24.94.23 1.34-.01l1.4-.9c.29-.17.57-.72.57-1.09 0-.41.34-.75.75-.75s.75.34.75.75c0 .9-.56 1.93-1.27 2.36l-1.39.9a2.863 2.863 0 0 1-2.87.05z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.121 13.32c0-2.18 1.77-3.95 3.95-3.95s3.95 1.77 3.95 3.95-1.77 3.95-3.95 3.95-3.95-1.77-3.95-3.95zm1.5 0c0 1.35 1.1 2.45 2.45 2.45s2.45-1.1 2.45-2.45-1.1-2.45-2.45-2.45-2.45 1.1-2.45 2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.34 17.65-1-1a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1 1c.29.29.29.77 0 1.06-.14.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineFilterSearch);
export default __webpack_public_path__ + "static/media/vuesax-outline-filter-search.774a85c209bdcb954d32c95054b8701f.svg";
export { ForwardRef as ReactComponent };